import { render, staticRenderFns } from "./BDjhTable.vue?vue&type=template&id=f928cbca&scoped=true"
import script from "./BDjhTable.vue?vue&type=script&lang=js"
export * from "./BDjhTable.vue?vue&type=script&lang=js"
import style0 from "./BDjhTable.vue?vue&type=style&index=0&id=f928cbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f928cbca",
  null
  
)

export default component.exports